import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
function SvgComponent(props) {
    return (React.createElement(Svg, { width: props.size, height: props.size, viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', ...props },
        React.createElement(Path, { d: 'M12.563 10a.611.611 0 00-.042-.23.636.636 0 00-.146-.207L8.25 5.436a.573.573 0 00-.448-.156.64.64 0 00-.448.177c-.139.14-.198.289-.177.448.021.16.087.302.198.427L11.042 10l-3.667 3.667a.68.68 0 00-.187.448.493.493 0 00.187.447.46.46 0 00.438.178.811.811 0 00.458-.198l4.104-4.104a.636.636 0 00.146-.209.612.612 0 00.042-.229z', fill: props.color || '#1434CB' })));
}
export default SvgComponent;
